import { TICKER_ITEMS } from "../../data/home";

export default function Ticker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <div className="bg-gold overflow-hidden py-3.5" role="marquee" aria-label="Services offered">
      <div
        className="flex w-max"
        style={{ animation: "ticker 22s linear infinite" }}
      >
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-5 px-8 font-syne text-[10.5px] font-bold tracking-[0.2em] uppercase text-ink whitespace-nowrap"
          >
            {item}
            <span className="w-1 h-1 rounded-full bg-ink/35" aria-hidden="true" />
          </span>
        ))}
      </div>

      <style>{`
        @keyframes ticker {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
